var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showLoader)?_c('div',{staticClass:"page__loader"},[_c('QlashLoader')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }